import { useEffect, useState } from 'react';
import { screenSmMin } from '@spotify-internal/encore-web';

/**
 * Hook which returns if user is in mobile view
 * @return {boolean} isMobileView check if is in mobile view
 */
const useMobileView = () => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const mobileQuery = `(max-width: ${screenSmMin})`;

    const checkIsMobile = () => {
      if (typeof window === 'undefined') {
        return false;
      }

      return window.matchMedia(mobileQuery).matches;
    };

    const handleChange = () => {
      setIsMobileView(checkIsMobile());
    };

    const matchMedia = window.matchMedia(mobileQuery);
    handleChange();

    matchMedia.addEventListener('change', handleChange);

    return () => matchMedia.removeEventListener('change', handleChange);
  }, []);

  return isMobileView;
};

export default useMobileView;
